import { Directive, Input, TemplateRef, ViewContainerRef, effect, inject, signal } from '@angular/core';
import { AppAuthService } from '../services/app-auth.service';
import { AppLogService } from '../services/app-log.service';

@Directive({
  selector: '[ifRoles]',
  standalone: false,
})
export class IfRolesDirective {
  @Input('ifRoles') set ifRolesInput(role: string[] | null | undefined) {
    this._userRoles.set(role ?? []);
  }

  private _userRoles = signal<string[]>([]);
  private _viewCreated = false;

  /**
   * @param {ViewContainerRef} viewContainerRef -- the location where we need to render the templateRef
   * @param {TemplateRef<any>} templateRef -- the templateRef to be potentially rendered
   * @param {AppAppAuthService } appAppAuthService  -- will give us access to the roles a user has
   */
  private _viewContainerRef = inject(ViewContainerRef);
  private _templateRef = inject(TemplateRef<unknown>);
  private _authService = inject(AppAuthService);

  constructor() {
    effect(() => {
      try {
        const roles = this._authService.roles() ?? [];
        const requiredRoles = this._userRoles() ?? [];

        const hasAccess = !requiredRoles?.length || requiredRoles?.some(r => roles.includes(r));

        if (hasAccess && !this._viewCreated) {
          this._viewContainerRef.createEmbeddedView(this._templateRef);
          this._viewCreated = true;
        } else if (!hasAccess && this._viewCreated) {
          this._viewContainerRef.clear();
          this._viewCreated = false;
        }
      } catch (error) {
        AppLogService.error('Error ifRoles directive');
        AppLogService.error(error);
      }
    });
  }
}
